import { gql } from '@apollo/client'
import { useSort } from '@btime/react-contexts'
import React from 'react'

import { serviceOrdersClient } from '../../../../../../utils/apollo/api'
import { useQuery } from '../../../../../../utils/apollo/_helpers/useQuery'
import { useServiceOrder } from '../../../_load/ServiceOrderLoader'
import StatePresenter from '../../../../../../components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useRelatedServiceOrdersState = () => React.useContext(Context)
export const useRelatedServiceOrders = () => useRelatedServiceOrdersState()?.serviceOrders

const QUERY = gql`
  query ServiceOrders($filter: ServiceOrderFilter, $sort: ServiceOrderSort) {
    serviceOrders(filter: $filter, recursive: true, sort: $sort) {
      id
      name
      yearlyId
      endDate
      insertedAt
      status {
        id
        name
        label
        color
      }
      user {
        id
        name
      }
      place {
        id
        name
        resume
      }
      checklist {
        id
        name
      }
    }
  }
`

const RelatedServiceOrdersLoader = ({ children }) => {
  const serviceOrder = useServiceOrder()

  const { data, ...state } = useQuery(QUERY, {
    variables: {
      filter: { ids: serviceOrder.parentId || serviceOrder.id },
      sort: { field: 'INSERTED_AT', type: 'ASC' }
    },
    client: serviceOrdersClient
  })

  return (
    <StatePresenter {...state}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}
export default RelatedServiceOrdersLoader
